import * as yup from "yup"
import validationMessages from "@utils/validation/messages";

const signatureRequired = () =>
    yup.mixed()
        .test(
            "signature",
            validationMessages.signatureRequired,
            checkIfValueIsZero
        )
        .test(
            "signature",
            validationMessages.signatureTooSmall,
            checkIfTooSmall
        )

export default signatureRequired

const checkIfValueIsZero = (value: any): boolean => {
    if (!value) return false
    return true
}

const checkIfTooSmall = (value: any): boolean => {
    if(value === "too-small") return false
    return true
}